import { GlobalEventEmitterContext } from '@components/EventEmitterProvider';
import { useContext } from 'react';

export const useGlobalEventEmitter = () => {
  return useContext(GlobalEventEmitterContext);
};
